import { BaseFetch } from "../main-model"
export default class ConstructionInfoModel extends BaseFetch {
  getConstructionInfoBy = (data) =>
    this.authFetch({
      url: "construction-info/getConstructionInfoBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getConstructionInfoById = (data) =>
    this.authFetch({
      url: "construction-info/getConstructionInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateConstructionInfoById = (data) =>
    this.authFetch({
      url: "construction-info/updateConstructionInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertConstructionInfo = (data) =>
    this.authFetch({
      url: "construction-info/insertConstructionInfo",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteConstructionInfoById = (data) =>
    this.authFetch({
      url: "construction-info/deleteConstructionInfoById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
